import React, { memo, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';

import { DynamicIconWrapper, Icons, Tooltip } from '@components/common';
import ImportMapDataContainer from '@components/ModalComponents/ImportMapDataContainer';

import { auth, map } from '@store/selectors';
import { useAppDispatch, useAppSelector } from '@store/store';

import { setDrawTool, setMapMode } from '@slices/map';

import { EImportingDataType } from '@enums/dropzone';
import { EMapMode, EPolygonType } from '@enums/map';

import {
	acceptedPolygonFileTypes,
} from '@components/ModalComponents/ImportMapDataContainer/ImportMapData/UploadFile/constants';

import styles from './CustomPolygonControls.module.scss';
import controlStyles from '@components/Map/MapControls/MapControls.module.scss';

const portalImportPolygons = document.getElementById('portal-import-polygons');

const CustomPolygonControls = () => {
	const dispatch = useAppDispatch();
	const { drawTool, mapMode } = useAppSelector(map);
	const { accessPermission } = useAppSelector(auth);

	const { platformOwnerAdministrator } = accessPermission;

	const [isImportPolygonModalOn, setIsImportPolygonModalOn] = useState(false);

	const toggleImportPolygonModal = () => setIsImportPolygonModalOn(!isImportPolygonModalOn);

	const enableDrawPolygonMode = (e: React.SyntheticEvent) => {
		e.stopPropagation();

		dispatch(setMapMode(EMapMode.draw));
		dispatch(setDrawTool(EPolygonType.polygon));
	};
	const _enableDrawCircleMode = () => dispatch(setDrawTool(EPolygonType.circle));

	useEffect(() => {
		return () => {
			dispatch(setMapMode(EMapMode.view));
		};
	}, [dispatch]);

	return (
		<div className={cn(controlStyles.controlItemContainer, styles.container)}>
			<Tooltip content='Draw polygon'>
				<div onClick={enableDrawPolygonMode}>
					<DynamicIconWrapper
						icon={Icons.polygon}
						isActive={drawTool === EPolygonType.polygon && mapMode === EMapMode.draw}
					/>
				</div>
			</Tooltip>
			{!platformOwnerAdministrator && (
				<>
					<Tooltip content='Import polygons from file'>
						<div onClick={toggleImportPolygonModal}>
							<DynamicIconWrapper
								icon={Icons.import}
								isActive={drawTool === EPolygonType.circle}
							/>
						</div>
					</Tooltip>
					{portalImportPolygons && isImportPolygonModalOn && ReactDOM.createPortal(
						<ImportMapDataContainer
							acceptedFileTypes={acceptedPolygonFileTypes}
							importType={EImportingDataType.polygon}
							isShowImportModal={isImportPolygonModalOn}
							toggleImportModal={toggleImportPolygonModal}
						/>,
						portalImportPolygons,
					)}
				</>
			)}
		</div>
	);
};

export default memo(CustomPolygonControls);
